import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';

const removeAccount = async ({
  clientId,
  accountId,
}: {
  clientId: string | number;
  accountId: string;
}): Promise<string> =>
  authFetch('/Consumer/AccountUpdate/DeleteAccount', {
    method: 'POST',
    ...httpBodyOptions({ clientId, AccountId: accountId }),
  });

export const useRemoveAccount = () => {
  return useMutation(removeAccount);
};
